/* eslint-disable prefer-promise-reject-errors */
const contentstack = require('contentstack')

const params = new URLSearchParams(window.location.search)
const marketLang = params.get('locale')

function getCountry() {
  return marketLang.split('_')[1]
}

function getLanguage() {
  return marketLang.split('_')[0]
}

function detectStage(url = window.location.href) {
  const parsed = new URL(url)
  const host = parsed.hostname
  switch (host) {
    case 'apps.dev.nuskin.io':
    case 'dev.nuskin.com':
      return 'dev'
    case 'localhost':
      return 'local'
    case 'test.nuskin.com':
      return 'test'
    case 'www.nuskin.com':
      return 'prod'
  }
}

let apiKey, deliveryToken, environment, config;

let country = getCountry()
let locale = `${getCountry()}-${getLanguage()}`

switch (locale) {
  case 'ID-in':
    locale = 'ID-id'
    break
  default:
}

const stage = detectStage()

try {
    const environmentConfig = require(`../config/${stage}.json`);
    apiKey = environmentConfig.contentstack.apiKey;
    deliveryToken = environmentConfig.contentstack.deliveryToken;
    environment = environmentConfig.contentstack.environment;
    config = environmentConfig
} catch (error) {
    console.error(
        `Error retrieving environment config. Environment: '${stage}' : ${error}`
    );
}

const Stack = contentstack.Stack(apiKey, deliveryToken, environment, 'us')

if (process.env.custom_host) {
  Stack.setHost(process.env.custom_host)
}

function getEntry(contentTypeUid) {
  const data = new Promise((resolve, reject) => {
    Stack.ContentType(contentTypeUid)
      .Query()
      .language(locale)
      .includeFallback()
      .toJSON()
      .find()
      .then(
        function success(result) {
          if (result) {
            resolve(result[0]);
          } else {
            return reject("Internal Error");
          }
        },
        function error(error) {
          return reject(error);
        }
      );
  });
  return data;
}

function getSubEntry(type, uuid) {
  const data = new Promise((resolve, reject) => {
    Stack.ContentType(type)
      .Entry(uuid)
      .language(locale)
      .includeFallback()
      .fetch()
      .then(
        function success(entry) {
          if (entry) {
            resolve(entry.toJSON())
          } else {
            reject("Error")
          }
        },
        function error(err) {
          reject(err)
        }
      );
  });
  return data
}

function getAsset(uuid) {
  const data = new Promise((resolve, reject) => {
    Stack.Assets(uuid)
      .fetch()
      .then(
        function success(asset) {
          resolve(asset.toJSON())
        },
        function error(err) {
          reject(err)
        }
      )
  })
  return data
}

function getConfig(title) {
  const data = new Promise((resolve, reject) => {
    Stack.ContentType('config_map')
      .Query()
      .where('title', title)
      .toJSON()
      .find()
      .then(
        async function success(result) {
          if (result) {
            let configObj = {}
            for (let i = 0; i < result[0][0].configs.length; i++) {
              let overrideObj = {}
              let config = await getSubEntry(
                result[0][0].configs[i]._content_type_uid,
                result[0][0].configs[i].uid
              )
              if (config.market_overrides.length) {
                overrideObj = config.market_overrides.reduce(
                  (accum, { markets }) => ({
                    ...accum,
                    [markets.market]: markets.value,
                  }),
                  {}
                )
              }
              if (overrideObj[country]) {
                configObj[config.title] = overrideObj[country]
              } else {
                configObj[config.title] = config.value
              }
            }
            resolve(configObj)
          } else {
            return reject('Internal Error')
          }
        },
        function error(error) {
          return reject(error)
        }
      )
  })
  return data
}

export default {
  getEntry,
  getSubEntry,
  getAsset,
  getConfig,
  config,
}
